import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

import { ref, reactive } from 'vue';
import type { FormInstance, FormRules } from 'element-plus';
import type { Company } from '@/types/company';
import { Link } from '@element-plus/icons-vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CompanyForm',
  props: {
    initialData: {},
    loading: { type: Boolean }
  },
  emits: ["submit"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const formRef = ref<FormInstance>();
const formData = reactive({
  name: props.initialData?.name || '',
  companyType: props.initialData?.companyType || '',
  industry: props.initialData?.industry || '',
  location: props.initialData?.location || '',
  recruitmentUrl: props.initialData?.recruitmentUrl || '',
  contactPerson: props.initialData?.contactPerson || '',
  notes: props.initialData?.notes || '',
  status: props.initialData?.status || 'planned',
  isStarred: props.initialData?.isStarred || false,
  isPinned: props.initialData?.isPinned || false,
});

const rules: FormRules = {
  name: [
    { required: true, message: '公司名称不能为空', trigger: 'blur' },
    { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
  ],
  companyType: [
    { required: true, message: '公司类型不能为空', trigger: 'change' }
  ],
  recruitmentUrl: [
    { required: true, message: '招聘网站链接不能为空', trigger: 'blur' },
    { 
      pattern: /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/, 
      message: '请输入有效的URL', 
      trigger: 'blur' 
    }
  ],
  status: [
    { required: true, message: '请选择状态', trigger: 'change' }
  ]
};

// 提交表单
const submitForm = async () => {
  if (!formRef.value) return;
  
  await formRef.value.validate((valid, fields) => {
    if (valid) {
      emit('submit', {
        ...formData,
        id: props.initialData?.id,
        recruitmentUrl: formData.recruitmentUrl ? 
          (formData.recruitmentUrl.startsWith('http') ? formData.recruitmentUrl : `https://${formData.recruitmentUrl}`)
          : '',
        createTime: props.initialData?.createTime
      });
    }
  });
};

// 打开URL链接
const openUrl = (url: string) => {
  let finalUrl = url;
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    finalUrl = 'https://' + url;
  }
  window.open(finalUrl, '_blank');
};

// 暴露方法给父组件
__expose({
  submitForm
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    ref_key: "formRef",
    ref: formRef,
    model: formData,
    rules: rules,
    "label-width": "100px",
    class: "company-form"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, {
        label: "公司名称",
        prop: "name"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: formData.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.name) = $event)),
            placeholder: "请输入公司名称",
            clearable: ""
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "公司类型",
        prop: "companyType"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            modelValue: formData.companyType,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.companyType) = $event)),
            placeholder: "请选择公司类型",
            class: "full-width",
            clearable: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "大厂",
                value: "大厂"
              }),
              _createVNode(_component_el_option, {
                label: "外企",
                value: "外企"
              }),
              _createVNode(_component_el_option, {
                label: "国企",
                value: "国企"
              }),
              _createVNode(_component_el_option, {
                label: "创业公司",
                value: "创业公司"
              }),
              _createVNode(_component_el_option, {
                label: "其他",
                value: "其他"
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "所属行业",
        prop: "industry"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: formData.industry,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.industry) = $event)),
            placeholder: "请输入所属行业",
            clearable: ""
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "所在地",
        prop: "location"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: formData.location,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.location) = $event)),
            placeholder: "请输入公司所在地",
            clearable: ""
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "招聘官网",
        prop: "recruitmentUrl"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: formData.recruitmentUrl,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.recruitmentUrl) = $event)),
            placeholder: "请输入招聘官网地址",
            clearable: ""
          }, {
            append: _withCtx(() => [
              (formData.recruitmentUrl)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (openUrl(formData.recruitmentUrl)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Link))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "联系人",
        prop: "contactPerson"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: formData.contactPerson,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.contactPerson) = $event)),
            placeholder: "请输入联系人姓名",
            clearable: ""
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "备注",
        prop: "notes"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: formData.notes,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.notes) = $event)),
            type: "textarea",
            rows: 3,
            placeholder: "请输入备注信息"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "状态",
        prop: "status"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            modelValue: formData.status,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.status) = $event)),
            placeholder: "请选择状态",
            class: "full-width",
            clearable: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "计划投递",
                value: "planned"
              }),
              _createVNode(_component_el_option, {
                label: "已投递",
                value: "applied"
              }),
              _createVNode(_component_el_option, {
                label: "面试中",
                value: "interviewing"
              }),
              _createVNode(_component_el_option, {
                label: "已录用",
                value: "offered"
              }),
              _createVNode(_component_el_option, {
                label: "已拒绝",
                value: "rejected"
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_space, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_checkbox, {
                modelValue: formData.isStarred,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.isStarred) = $event))
              }, {
                default: _withCtx(() => _cache[11] || (_cache[11] = [
                  _createTextVNode("收藏公司")
                ])),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: formData.isPinned,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.isPinned) = $event))
              }, {
                default: _withCtx(() => _cache[12] || (_cache[12] = [
                  _createTextVNode("置顶显示")
                ])),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model"]))
}
}

})